import { render, staticRenderFns } from "./CPacker.vue?vue&type=template&id=cc7073c6&scoped=true"
import script from "./CPacker.vue?vue&type=script&lang=js"
export * from "./CPacker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7073c6",
  null
  
)

export default component.exports